import { Redirect } from 'react-router-dom';
import { RouteConfig } from 'react-router-config';
import { NotFound } from '../pages/not-found';
import { NewHomeRoute } from '../pages/new-home';
import { GetStarted } from '../pages/get-started';
import { TemplateEmpty } from './templates/empty';
import { ProductsComponent } from '../pages/products';
import { RoadmapComponent } from '../pages/roadmap';

const NOT_FOUND_ROUTE: RouteConfig[] = [
  {
    path: '/404',
    exact: true,
    component: NotFound,
  },
  {
    path: '*',
    render: () => <Redirect to={'/404'} />,
  },
];

const childRoutes: RouteConfig[] = [
  {
    path: '/',
    exact: true,
    component: NewHomeRoute,
  },
  {
    path: '/get-started',
    exact: true,
    component: GetStarted,
  },
  {
    path: '/products/:uniqueName',
    exact: true,
    component: ProductsComponent,
  },
  {
    path: '/roadmap',
    exact: true,
    component: RoadmapComponent,
  },
  ...NOT_FOUND_ROUTE,
];

const ROUTES_CONFIG: RouteConfig[] = [
  {
    path: '/',
    component: TemplateEmpty,
    routes: childRoutes,
  },
];

export default ROUTES_CONFIG;

